/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-12-01 22:30:09
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import Modal from 'src/types/iview/Modal';
import Button from 'src/types/iview/Button';
import Input from 'src/types/iview/Input';
import { Toast } from 'src/util/toast';
import { modalFactory } from 'src/util/vueExtend';
import { Integer, IViewDate } from 'src/types/base';
import { createNamespace } from 'src/util/bem';
import SystemSetApi, { SystemSetDOI } from './api/systemSetApi';
import EnumOperates from 'src/enums/enumOperates';

export namespace SystemSetOperateVOI {
    export interface PropsI {
        operate: string;
        id?: number;
        saveSuccess?(): void;
        cancel?(): void;
    }

    export interface FormDataI {
        id?: Integer;
        mn: string;
        device_name: string;
        ip: string;
        port: string;
    }
}

@Component
class SystemSetOperateModal extends Vue.Component<SystemSetOperateVOI.PropsI> {
    @Prop({
        type: Function,
    })
    cancel!: () => void;

    @Prop({
        type: Number,
    })
    id!: number;

    @Prop({
        type: String,
    })
    operate!: string;

    @Prop({
        type: Function,
    })
    saveSuccess!: () => void;

    visible: boolean = false;

    loading: boolean = false;

    formData: SystemSetOperateVOI.FormDataI = {
        id: null,
        mn: '',
        device_name: '',
        ip: '',
        port: '',

    };
    rules: any = {};

    close() {
        this.cancel && this.cancel();
        this.closeModal();
    }

    closeModal() {
        this.visible = false;
        this.$emit('close', false);
    }

    async save() {
        if (!(await this.$validate('formValidate'))) {
            return;
        }
        let res;
        this.loading = true;
        let params: SystemSetDOI.OperateParamsI = {
            ...this.formData,
        };
        switch (this.operate) {
            case EnumOperates.Add.getName():
                res = await SystemSetApi.addDevice(params);
                break;
            case EnumOperates.Update.getName():
                // debugger
                res = await SystemSetApi.editDevice(params);
                break;
        }
        this.loading = false;
        let { code } = res;
        if (code === 0) {
            Toast.success(this.operate + '成功');
            this.saveSuccess();
            this.closeModal();
        }
    }
    async mounted() {
        if (this.operate === EnumOperates.Update.getName()) {
            let { code, data } = await SystemSetApi.queryDevice({id: this.id});
            if (code === 0) {
                this.formData = {
                    ...data[0],
                    device_name: data[0].name,
                };
                setTimeout(()=> {
                    (this.$refs.area as any).matchData()
                })
            }
        }
    }
    created() {
        let t = this;
        this.rules = {
            // area: [
            //     {
            //         validator(rule, value, callback) {
            //             if (t.formData.area.some(i => CommonUtil.isFieldEmpty(i)) || !t.formData.address) {
            //                 callback(new Error('请填选地址'));
            //             } else {
            //                 callback();
            //             }
            //         },
            //         trigger: 'blur',
            //     },
            // ],
        };
    }

    render(h) {
        return (
            <Modal
                class={createNamespace('modal')}
                title={this.operate}
                width="600"
                v-model={this.visible}
                mask-closable={false}
                on-on-cancel={this.close}
            >
                <i-form class={createNamespace('mt20')} ref="formValidate" labelWidth={100} model={this.formData} rules={this.rules}>
                    <form-item label="站点名称" prop="device_name" style="width:90%" required>
                        <Input v-model={this.formData.device_name} placeholder="请输入" />
                    </form-item>
                    <form-item label="mn号" prop="mn" style="width:90%" required>
                        <Input v-model={this.formData.mn} placeholder="请输入" />
                    </form-item>
                    <form-item label="ip地址" prop="ip" style="width:90%" required>
                        <Input v-model={this.formData.ip} placeholder="请输入" />
                    </form-item>

                    <form-item label="端口" prop="port" style="width:90%">
                        <Input v-model={this.formData.port} placeholder="请输入" />
                    </form-item>

                </i-form>
                <div slot="footer">
                    <Button type="primary" ghost on-click={this.close}>
                        取消
                    </Button>
                    <Button type="primary" on-click={this.save} loading={this.loading}>
                        保存
                    </Button>
                </div>
            </Modal>
        );
    }
}

export default function alertStationOperateModal(operate: string, id?: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
        modalFactory<SystemSetOperateVOI.PropsI>(SystemSetOperateModal)({
            id,
            operate,
            saveSuccess() {
                resolve(true);
            },
            cancel() {
                resolve(false);
            },
        });
    });
}
